export default "__VITE_ASSET__DXraqUx6__";